import { useQuery } from "react-query";
import FormListBox from "../../../components/ui-lib/form/FormListBox";
import { School } from "../../../models/school/school";
import { FormWizardStepProps } from "../../../models/form-wizard-step-props";
import { useTeachers } from "../../../states/cache-state/useTeachers";
import { VacancyFormFields } from "../VacancyCreateWizard";

function TeacherSelectionStep({
  control,
  register,
  errors,
  school,
}: FormWizardStepProps<VacancyFormFields> & { school: School }) {
  const { getTeachersOfSchool } = useTeachers();
  const { data: teachers } = useQuery(["teachers", school.id], () =>
    getTeachersOfSchool(school.id, false),
  );

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="space-y-4">
        <h2
          className="text-center text-th-primary-900"
          data-cy="wizard-step-title"
        >
          Ausfallende Lehrperson
        </h2>
        <FormListBox
          className="md:w-[300px]"
          name="teacher"
          control={control}
          values={teachers ?? []}
          itemDisabled={(_) => false}
          valueKey={(t) => t.fullName}
          valueIdentifier={(t) => t.id}
          errors={errors as any}
          rules={{
            required: "Sie müssen eine Lehrperson selektieren.",
          }}
          placeholder="Kranke Lehrperson wählen"
        ></FormListBox>
      </div>
    </div>
  );
}

export default TeacherSelectionStep;
